import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Select, SelectValue, Slider } from 'tdesign-react';

import styles from './index.module.less';
import RecommendedRatiosComponent from './recommendedRatios';

const MIN_DIMENSION = 512;
const MAX_DIMENSION = 1376;
const MIN_RATIO = MIN_DIMENSION / MAX_DIMENSION;
const MAX_RATIO = MAX_DIMENSION / MIN_DIMENSION;

export interface IProps {
  onChange: (key: any) => void;
  value: { width: number, height: number };
  ratio: { width: number, height: number };
}

const CustomAigcRatio: React.FC<IProps> = (props) => {
  const { onChange, value, ratio } = props;
  const [aspectRatio, setAspectRatio] = useState<string>('recommended');
  const [width, setWidth] = useState<number>(value.width);
  const [height, setHeight] = useState<number>(value.height);

  useEffect(() => {
    if (!ratio.width || !ratio.height) return;
    let w = ratio.width;
    let h = ratio.height;
    const r = w / h;

    if (w >= MIN_DIMENSION && w <= MAX_DIMENSION && h >= MIN_DIMENSION && h <= MAX_DIMENSION) {
      handleChange(w, h);
      setAspectRatio('custom');
    } else if (r >= MIN_RATIO && r <= MAX_RATIO) {
      const scale = Math.min(MAX_DIMENSION / w, MAX_DIMENSION / h);
      w *= scale;
      h *= scale;
      handleChange(Math.round(w), Math.round(h));
      setAspectRatio('custom');
    }
  }, [ratio.width, ratio.height]);

  useEffect(() => {
    if (value) {
      setWidth(value.width);
      setHeight(value.height);
    }
  }, [value]);

  const handleAspectRatioChange = (value: SelectValue) => {
    setAspectRatio(value as string);
  };

  const handleChange = (w?: number, h?: number) => {
    const newW = w || width;
    const newH = h || height;
    setWidth(newW);
    setHeight(newH);
    onChange({ width: newW, height: newH });
  };

  return (
    <div className={classNames('custom-form-group', styles.container)} >
      <div className={styles.aspectRatio}>
        <Select
          value={aspectRatio}
          onChange={handleAspectRatioChange}
          style={{ width: '100%' }}
          options={[
            { label: '推荐比例', value: 'recommended' },
            { label: '自定义比例', value: 'custom' },
          ]}
          defaultValue={'recommended'}
        >
        </Select>
        {aspectRatio === 'custom' ? (
          <div className={styles.customRatioOptions}>
            <div>
              <span className={styles.label}>宽度：</span>
              <Slider
                label
                min={MIN_DIMENSION}
                max={MAX_DIMENSION}
                inputNumberProps
                value={width}
                onChange={val => handleChange(val as number, undefined)}
                style={{ flex: 1 }}
              />
            </div>
            <div>
              <span className={styles.label}>高度：</span>
              <Slider
                label
                min={MIN_DIMENSION}
                max={MAX_DIMENSION}
                inputNumberProps
                value={height}
                onChange={val => handleChange(undefined, val as number)}
                style={{ flex: 1 }}
              />
            </div>
          </div>
        ) : (
          <RecommendedRatiosComponent onSelect={(width, height) => {
            handleChange(width, height);
          }} />
        )}
      </div>
    </div>
  );
};

export default CustomAigcRatio;
